import { EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Tooltip, Switch } from 'antd';
import { Text } from 'atoms';
import { getLocalDate } from 'utils/helpers';

export const NodeTableConfigV2 = [
	{
		title: 'Node Name',
		dataIndex: 'node_name',
		key: 'node_name',
		hidden: false,
		render: (text) => <Text fontWeight="500">{text || '-'}</Text>,
	},
	{
		title: 'Project Name',
		dataIndex: 'project_name',
		key: 'project_name',
		hidden: false,
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Node Type',
		dataIndex: 'node_type',
		key: 'node_type',
		hidden: false,
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Node Address',
		dataIndex: 'node_address',
		key: 'node_address',
		width: '15%',
		hidden: false,
		render: (address) => {
			if (!address) return <Text>-</Text>;

			// Parse string to object if needed
			let addressObj = address;
			if (typeof address === 'string') {
				try {
					addressObj = JSON.parse(address);
				} catch {
					// If parsing fails, treat as plain string
					return (
						<Tooltip title={address}>
							<Text
								style={{
									maxWidth: '200px',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
								}}
							>
								{address}
							</Text>
						</Tooltip>
					);
				}
			}

			// Extract only line1 from node_address object
			const line1 = addressObj?.line1 || '-';

			return (
				<Tooltip title={line1}>
					<Text
						style={{
							maxWidth: '200px',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
						}}
					>
						{line1}
					</Text>
				</Tooltip>
			);
		},
	},
	{
		title: 'City',
		dataIndex: 'city',
		key: 'city',
		hidden: false,
		render: (text, record) => {
			// Try to get city from node_address if not directly available
			const city = text || record?.node_address?.city || '-';
			return <Text>{city}</Text>;
		},
	},
	{
		title: 'Coordinates',
		key: 'coordinates',
		hidden: false,
		render: (_, record) => (
			<Text>
				{record.latitude}-{record.longitude}
			</Text>
		),
	},
	{
		title: 'PoC Name',
		dataIndex: 'poc_name',
		key: 'poc_name',
		hidden: false,
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Created At',
		dataIndex: 'created_at',
		key: 'created_at',
		hidden: false,
		render: (text) => <Text>{getLocalDate(text)}</Text>,
	},
	{
		title: 'Created by',
		dataIndex: 'created_by_name',
		key: 'created_by_name',
		hidden: false,
		render: (text) => <Text>{text || '-'}</Text>,
	},
	{
		title: 'Status',
		dataIndex: 'is_active',
		key: 'is_active',
		hidden: false,
		// Render function will be overridden in component to include handleStatusToggle
		render: (isActive) => (
			<Switch
				checked={isActive}
				checkedChildren="Active"
				unCheckedChildren="Inactive"
				style={{
					backgroundColor: isActive ? '#1990FF' : '#C6C6C8',
				}}
			/>
		),
	},
	{
		title: 'View',
		key: 'view',
		width: '5%',
		hidden: false,
		render: (_, record) => (
			<Link to={`/nodes/${record.id}`}>
				<EyeOutlined style={{ color: '#1890ff', fontSize: '16px' }} />
			</Link>
		),
	},
];
